'use strict';

export default class Video {
  constructor() {
    // console.log('Video module');
  }
}
